'use strict';

module.exports = root;
var lineFeed = '\n'; // Stringify a root.
// Adds a final newline to ensure valid POSIX files. */

function root(node) {
  var doc = this.block(node);

  if (doc.charAt(doc.length - 1) !== lineFeed) {
    doc += lineFeed;
  }

  return doc;
}